import { UserEffects } from './effects/user.effects';
import { AuthorizationEffects } from './effects/authorization.effects';


export const effects = [
    UserEffects,
    AuthorizationEffects
];
